import { getChatClient } from '../client'
import { ChatLocalMesage, isThreadMessage } from '@packages/chat'
import { useThreadNavigation } from './useThreadNavigation'
import { useChannelActionContext } from 'stream-chat-react'
import { waitFor } from '@codeleap/utils'
import { appStatusStore } from '@/stores'

export function usePinnedMessageNavigation() {
  const { openThread } = useThreadNavigation()
  const { jumpToMessage } = useChannelActionContext()

  const openPinnedMessage = async (pinnedMessage: ChatLocalMesage) => {

    if (isThreadMessage(pinnedMessage)) {
      const chatClient = await getChatClient()
      const parentMessage = await chatClient.getMessage(pinnedMessage.parent_id)
      if (parentMessage) {
        appStatusStore.set('loading')
        openThread(parentMessage?.message as unknown as ChatLocalMesage)
        await waitFor(300)
        await jumpToMessage(pinnedMessage.id)
        appStatusStore.set('idle')
      }
    } else {
      appStatusStore.set('loading')
      await jumpToMessage(pinnedMessage.id)
      appStatusStore.set('idle')
    }

  }

  return { openPinnedMessage }
}
